import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import * as moment from 'moment'
import { Observable } from 'rxjs'
import { mergeMap, tap } from 'rxjs/operators'
import { ConfigService } from '../../../../config/config.service'
import { Client } from '../../../shared/client/client'
import { Group } from './group'
import { RoleHierarchy } from './role-hierarchi'
import { Site } from './site'
import { User } from './user'

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private configService: ConfigService,
    private http: HttpClient) { }

  public getClientUsers(nameFilter: string = ""): Observable<Array<User>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Array<User>>(config.apiPoint + config.getUsers, {
          params: {
            nameFilter: nameFilter
          }
        })
      })
    )
  }

  public getRoles(): Observable<Array<RoleHierarchy>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Array<RoleHierarchy>>(config.apiPoint + config.getRoles)
      })
    )
  }

  public getSites(): Observable<Array<Site>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Array<Site>>(config.apiPoint + config.getSites)
      })
    )
  }

  public getClientsCommand(nameFilter: string): Observable<Array<Client>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Array<Client>>(config.apiPoint + config.getLHClients, {
          params: {
            "filter": nameFilter
          }
        })
      })
    )
  }

  public getClientsBesoin(nameFilter: string): Observable<Array<Client>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Array<Client>>(config.apiPoint + config.getBesoinClients, {
          params: {
            "filter": nameFilter
          }
        })
      })
    )
  }

  private prepareUserData(user: User) {
    return {
      civility: user.civility.id,
      username: user.username,
      email: user.email,
      lastname: user.lastname,
      firstname: user.firstname,
      phone: user.phone,
      enabled: user.enabled,
      is_anett: user.is_anett,
      roles: user.roles.map(role => role.id),
      clients: user.clients.map(client => client.id),
      site_affectation: user.site_affectation != null ? user.site_affectation.id : null,
      is_admin_site: user.is_admin_site,
      is_agent_distri: user.is_agent_distri,
      is_admin_distri: user.site_affectation != null ? user.site_affectation.numero == '0' : false
    }
  }

  public saveUser(user: User): Observable<User> {
    return this.configService.getConfig().pipe(

      mergeMap(config => {
        if (user.id != null) {
          return this.http.put<User>(config.apiPoint + config.getUser.replace('{user}', user.id),
            this.prepareUserData(user)
          )
        } else {
          return this.http.post<User>(config.apiPoint + config.postUsers, this.prepareUserData(user))
        }

      })
    )
  }

  public getClients(site: Site): Observable<Array<Client>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Array<Client>>(config.apiPoint + config.getClients, {
          params: {
            "siteFilter": site.numero,
          }
        });
      })
    );
  }

  public getProfileOfUser(userId: string): Observable<User> {
    return this.configService.getConfig().pipe(
      mergeMap(conf => {
        return this.http.get<User>(
          conf.apiPoint + conf.getUser.replace("{user}", userId)
        )
      })
    )
  }

  public getUserFromToken(token: string): Observable<User> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<User>(config.apiPoint + config.getUserFromToken.replace("{token}", token))
      })
    )
  }

  public exportUsers() {

    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get(
          config.apiPoint + config.getExportUsers, { responseType: 'arraybuffer' }
        ).pipe(
          tap(res => {
            let blob = new Blob([res], { type: 'application/vnd.ms-excel' });
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', `utilisateurs.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }));
      })
    );
  }

  public exportLastAccess() {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get(
          config.apiPoint + config.getExportLastAccess, { responseType: 'arraybuffer' }
        ).pipe(
          tap(res => {
            let blob = new Blob([res], { type: 'application/vnd.ms-excel' });
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', 'last_access_client_' + moment((new Date)).format("YMMDD") + '.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }));
      })
    );
  }
}
